import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter" }


export default /*@__PURE__*/_defineComponent({
  __name: 'StatusFilter',
  props: {
  searchParams: {
    type: Object,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.$t('Результат')), 1 /* TEXT */),
    _createVNode(_component_v_select, {
      modelValue: __props.searchParams['event.success'],
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.searchParams['event.success']) = $event)),
      placeholder: _ctx.$t('Результат'),
      items: [
          {title: _ctx.$t('Успешно'), value: true},
          {title: _ctx.$t('Ошибка'), value: false},
        ],
      "list-props": { class: 'api-events-page-select-filter-list' },
      "hide-details": "",
      variant: "solo"
    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "items"])
  ]))
}
}

})